import { media } from 'src/components/base';
import styled from 'styled-components';
import HorizontalScroll from '..';

/**
 * Styled variant of HorizontalScroll that fits:
 * 1) four product cards (ProductGridCard) on each "page" of the component.
 * 2) Four article previews
 */
export const MediumCardHorizontalScroll = styled(HorizontalScroll)`
  li > * {
    ${media.smallUp`
    width: 215px;
  `}

    ${media.mediumUp`
    width: 235px;
  `}
  }
`;
